import React, { FC } from 'react'

//* utils
import { LocaleCodes } from '../../../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../../../models/others/menuGroup'

//* components
import Layout from '../../../../layouts/layout'
import { PageInner } from './subcomponents/pageBody'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const WebinarRecordingPage: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  const pageData = pageContext.webinarRecordingData || null
  if (!pageData) return null

  const bioSpeakers = pageData.referrer?.bioRTF
  const speakers = Array.isArray(bioSpeakers) ? bioSpeakers : bioSpeakers?.references || []

  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const webinarRecordingData = {
    pageName: pageData.pageName || '',
    microcopy: pageData.microcopy?.values || [],
    flexSection: pageData.flexSection || [],
    rtfBody: pageData.referrer?.body || pageData.body || '',
    referrer: pageData.referrer || null,
    faqText: pageData.faqText || '',
    faqCta: pageData.faqCta || null,
    finePrint: pageData.finePrint || '',
    speakers,
    breadcrumb: pageData.breadcrumb || null,
    title: pageData.h1Title || '',
    webinarDate: pageData.webinarDate || '',
    spotlight: pageData.spotlight || null,
    number: pageData.resourceCategory?.number || '',
    slug: pageData.slug || '',
    seoMetadata: pageData.seoMetadata || null,
  }

  return (
    <Layout.Template
      lang={defaultLocale}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      minimalFooter={true}
      slug={webinarRecordingData.slug}
      availableLocales={pageContext.availableLocales}>
      <PageInner
        webinarRecordingData={webinarRecordingData}
        relatedResources={pageContext.relatedResources}
        path={path}
        locale={defaultLocale}
        availableLocales={pageContext.availableLocales}
        location={location}
      />
    </Layout.Template>
  )
}

export default WebinarRecordingPage
